var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPowerConsumption = function SvgPowerConsumption(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 347,
    height: 163,
    viewBox: "0 0 347 163",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.302,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65a844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(-250 -724)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_200",
    "data-name": 200,
    transform: "translate(267 834)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16,
    y: 0
  }, "200")), /*#__PURE__*/React.createElement("text", {
    id: "_100",
    "data-name": 100,
    transform: "translate(267 859)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16,
    y: 0
  }, "100")), /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(267 884)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    id: "_300",
    "data-name": 300,
    transform: "translate(267 809)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16,
    y: 0
  }, "300")), /*#__PURE__*/React.createElement("text", {
    id: "_400",
    "data-name": 400,
    transform: "translate(267 784)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16,
    y: 0
  }, "400")), /*#__PURE__*/React.createElement("text", {
    id: "_600",
    "data-name": 600,
    transform: "translate(267 734)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16,
    y: 0
  }, "600")), /*#__PURE__*/React.createElement("text", {
    id: "_500",
    "data-name": 500,
    transform: "translate(267 759)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16,
    y: 0
  }, "500")), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M250,737.06s2.743-8.169,9.1-8.488,7.482,13.867,11.841,14.4,5.849-6.135,9.2-5.917,5.252,2.191,7.108,8.234,3.342,14.394,8.278,14.25,2.6-21.511,8.433-21.876,5.467,4.8,10.765,4.855,6.835-10.069,7.416-15.882,3.459-12.855,8.408-13.013,9.743,31.062,10.506,41.626,5.426,15,11.526,14.478,7.248-10.546,12.547-14.478,7.851-5.787,15.787,0,9.511,33.219,19.4,33.571,14.6-5.577,17.755-17.125,4.585-19.809,8.152-29.177,8.412-17.407,16.736-18.667,15.3,5.081,20.594,19.12,9.018,41.439,22.41,40.8,16.314-14.247,26.359-14.046,18.209,19.583,25.592,19.093,14.669-6.787,18.617-15.214S570,761.144,570,761.144v97.3l-320,1.02Z",
    transform: "translate(27 27.533)",
    fill: "url(#linear-gradient)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPowerConsumption);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/power_consumption.8c212aaac6b86b6a3cfceca7ea0c9f1a.svg";